import { useState } from "react";
import { assetUrl } from "@/lib/api";
import { Disclosure } from "@/components/Provenance";

const Pane = ({ item, items, onPick, side }) => (
  <figure className="min-w-0" data-testid={`compare-pane-${side}`}>
    <div className="relative aspect-[4/3] overflow-hidden rounded-xl bg-[var(--bone-2)]">
      <img src={assetUrl(item.url)} alt={item.label} className="h-full w-full object-contain" />
      {!item.original && <Disclosure small testid={`compare-disclosure-${side}`} />}
      <span className="absolute left-2 top-2 rounded-full bg-[var(--bone)]/90 px-2 py-0.5 font-mono-ui text-[0.6rem] uppercase tracking-[0.08em]">{side}</span>
    </div>
    <select value={item.id} onChange={(e) => onPick(e.target.value)} className="mt-2 h-11 w-full rounded-xl border border-[var(--line)] bg-white/70 px-2 text-sm outline-none" data-testid={`compare-select-${side}`}>
      {items.map((x) => <option key={x.id} value={x.id}>{x.label}</option>)}
    </select>
  </figure>
);

export const Compare = ({ p }) => {
  const items = [...p.compare, { id: "original", url: p.originalUrl, label: "Original photo (current condition)", original: true }];
  const grounded = p.compare.find((x) => x.label.includes("Product Grounded") || x.label.includes("sourced"));
  const first = p.compare.find((x) => x.current) || p.compare[0];
  const second = (grounded && grounded.id !== first?.id && grounded) || p.compare.find((x) => x.id !== first?.id) || items[items.length - 1];
  const [a, setA] = useState(first?.id || "original");
  const [b, setB] = useState(second.id);
  const get = (id) => items.find((x) => x.id === id) || items[0];
  if (!p.compare.length) return null;
  return (
    <section data-testid="compare-section">
      <div className="eyebrow mb-1">{p.isClaimant ? "For the owner · compare" : "Compare"}</div>
      <p className="mb-4 text-sm text-[var(--stone-dark)]">Two visions or versions of this room, side by side{p.compare.length < 2 ? " — only one rendered so far, shown against the original" : ""}.</p>
      <div className="grid grid-cols-2 gap-3 sm:gap-5">
        <Pane item={get(a)} items={items} onPick={setA} side="A" />
        <Pane item={get(b)} items={items} onPick={setB} side="B" />
      </div>
    </section>
  );
};
